import { Box, Typography } from '@mui/material'
import { DownloadFile } from 'components/DownloadFile'
import { useTranslation } from 'react-i18next'
import { ITendersControlPanelSummary } from 'types/tender'

type Props = {
  controlPanelSummary: ITendersControlPanelSummary
}

export const QuotationPaymentFiles = ({ controlPanelSummary }: Props) => {
  const { t } = useTranslation()
  return (
    <>
      <Typography variant="h6">{t('quotation-files')}</Typography>
      <Box sx={{ display: 'flex', gap: '10px' }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography>{t('conditions')}:</Typography>
          <DownloadFile fileId={controlPanelSummary.termsFileId} />
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography>{t('contract-type')}:</Typography>
          <DownloadFile fileId={controlPanelSummary.contractTemplateFileId} />
        </Box>
        {/* TODO: add yekun protokol when be is ready */}
        {/* <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Typography>{t('final-protocol')}:</Typography>
          <DownloadFile fileId={controlPanelSummary.contractTemplateFileId} />
        </Box> */}
      </Box>
    </>
  )
}
